module.exports = __webpack_public_path__ + "img/Skirt-Back-B9.db487896.png";